import { createAsyncActions } from '../../utils';

export const activeJobsConstants = {
  SET_JOBS: '@@activeJobs/SET_JOBS',
  SEARCH_JOBS: createAsyncActions('@@activeJobs/SEARCH_JOBS'),
  FETCH_JOB_DETAILS: createAsyncActions('@@activeJobs/FETCH_JOB_DETAILS'),
  SET_SELECTED_JOB_DETAILS: '@@activeJobs/SET_SELECTED_JOB_DETAILS',
  SET_SELECTED_SEARCH_CONFIG: '@@activeJobs/SET_SELECTED_SEARCH_CONFIG',
  FETCH_JOB_SEARCH_CONFIGS: createAsyncActions('@@activeJobs/FETCH_JOB_SEARCH_CONFIGS'),

};

export const activeJobsActions = {
  fetchJobs: (searchQuery = '') => ({
    type: activeJobsConstants.SEARCH_JOBS.TRIGGER,
    payload: searchQuery,
  }),
  fetchJobDetails: (jobId) => ({
    type: activeJobsConstants.FETCH_JOB_DETAILS.TRIGGER,
    payload: jobId,
  }),
  setJobsInStore: (payload, meta) => ({
    type: activeJobsConstants.SET_JOBS,
    payload,
    meta,
  }),
  setSelectedJobDetails: (payload, meta) => ({
    type: activeJobsConstants.SET_SELECTED_JOB_DETAILS,
    payload,
    meta,
  }),
  getSearchConfigsForJob: (id) => ({
    type: activeJobsConstants.FETCH_JOB_SEARCH_CONFIGS.TRIGGER,
    payload: id,
  }),

  setSelectedSearchConfig: (config) => ({
    type: activeJobsConstants.SET_SELECTED_SEARCH_CONFIG,
    payload: config,
  }),

};
